import { Star, Quote } from "lucide-react";
import { cn } from "@/lib/utils";

export const ReviewCard = ({ review, className }) => {
  const isSummary = review.type === "summary";
  return (
    <figure
      className={cn(
        "group flex h-full flex-col border border-white/10 bg-ink-surface p-7 transition-colors duration-300 hover:border-gold/40",
        className,
      )}
      data-testid="review-card"
    >
      <div className="mb-5 flex items-center justify-between">
        <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-current" />
          ))}
        </div>
        {isSummary ? (
          <span className="font-heading text-[10px] font-bold uppercase tracking-[0.18em] text-steel/70">
            Review summary
          </span>
        ) : (
          <Quote className="h-8 w-8 text-white/10" />
        )}
      </div>
      <blockquote className="flex-1 text-[15px] leading-relaxed text-steel-light">
        {isSummary ? review.text : `“${review.text}”`}
      </blockquote>
      <figcaption className="mt-6 border-t border-white/10 pt-5">
        <div className="font-heading text-base font-bold text-white">{review.name}</div>
        <div className="mt-1 flex items-center gap-2 text-xs uppercase tracking-wide text-steel">
          <span>{review.location}</span>
          <span className="h-1 w-1 rounded-full bg-gold" />
          <span className="text-gold/80">{review.service}</span>
        </div>
      </figcaption>
    </figure>
  );
};
